<app-profile [userId]="userId" isAdmin="false" showAccountHolder="true" showMembers="true" [allowEdit]="true"
  [shortDate]="false" showHeader="true" header="ACCOUNT_DETAILS" showCloseButton="true">
</app-profile>